import "../pollyfills/set-media-query";

import { App } from "@mono/app";
import { Emh5Host } from "emh5-hybrid";
import React, { Component } from "react";
import { Trade } from "emrn-hybrid/Trade";
import { AppRegistry } from "react-native";
import { RootSiblingContainer } from "emrn-design";
import { BottomPopup, BottomPopupInstance } from "emrn-design/BottomPopup";

import { formatConsole, parseQueryString } from "./util";
import { TradeAccountStore } from "./TradeAccount/store";
import { TradeAccountLoginDialog } from "./TradeAccount/LoginDialog";
import "./../pollyfills/remove-touchable-outline";
class PureApp extends Component {
  private popup = React.createRef<BottomPopup>();

  constructor(props: any) {
    super(props);

    Trade.getAccountInfo = () => {
      return Promise.resolve(TradeAccountStore.getCurrent());
    };

    Trade.getHistoryTradeAccountInfos = () => {
      return Promise.resolve(TradeAccountStore.getHistory());
    };

    Trade.requestLogin = (request: Trade.RequestLoginRequest = {}) => {
      return new Promise<Trade.RequestLoginResponse>((resolve) => {
        let popInst: BottomPopupInstance | undefined;

        const destroy = () => {
          if (popInst) {
            popInst.dismiss();
            popInst = undefined;
          }
        };

        const onCancel = () => {
          destroy();
          resolve({ hasLogin: false, info: undefined });
        };

        const onLogin = (response: Trade.RequestLoginResponse) => {
          destroy();
          resolve(response);
        };

        popInst = this.popup.current?.show(
          <TradeAccountLoginDialog {...request} {...{ onLogin, onCancel }} />
        );
      }).then((response) => {
        TradeAccountStore.setCurrent(response);
        return response;
      });
    };
  }

  render() {
    return (
      <RootSiblingContainer>
        <BottomPopup ref={this.popup} />
        <App {...this.props} rootTag="#root" />
      </RootSiblingContainer>
    );
  }
}

formatConsole();
AppRegistry.registerComponent("EMApp", () => {
  return Emh5Host.isEastmoneyApp ? App : PureApp;
});
AppRegistry.runApplication("EMApp", {
  initialProps: parseQueryString(),
  rootTag: document.getElementById("root"),
});
